<!--  -->
<template>
  <div class="app-content">
    <!-- 轮播图容器 -->
    <div class="banner-container">
      <van-swipe :auto="false"
                 :show-indicators="false">
        <van-swipe-item v-for="(banner, index) in banners"
                        :key="index"
                        :class="{ 'is-active': index === 0 }">
          <img :src="meetingInfo?.photo"
               alt=""
               style="width: 100%; height: 100%;">
        </van-swipe-item>
      </van-swipe>
      <div class="indicator">{{ currentIndex + 1 }}/{{ banners.length }}</div>
    </div>
    <!-- 法会标题 -->
    <div class="communion-title">
      <div class="title-text">{{ meetingInfo?.name }}</div>
      <div class="communion-title-container"
           style="display: flex; flex-direction: row;">
        <img src="../assets/fashidengji-logo.png"
             alt=""
             style="width: 14px; height: 14px; margin-left: 14px;">
        <div class="communion-title-container-form">集体法会</div>
        <img src="../assets/fashidengjidingwei.png"
             alt=""
             style="width: 14px; height: 14px; margin-left: 14px;">
        <div class="communion-title-container-form">{{ meetingInfo?.address }}</div>
      </div>
    </div>
    <!-- 法会介绍容器-法会介绍 -->
    <div class="introduction-container"
         style="">
      <div class="title">法会介绍</div>
      <div class="introduction">
        <p>
          {{ meetingInfo?.introduce}}
        </p>
      </div>
    </div>
    <!-- 法会介绍容器-法会流程 -->
    <div class="introduction-container"
         v-if="meetingInfo?.process != 'null' && meetingInfo?.process != null ">
      <div class="title">法会流程</div>
      <div class="introduction">{{ meetingInfo?.process }}</div>
    </div>
    <!-- 法会介绍容器-法会时间 -->
    <div class="introduction-container"
         style="">
      <div class="title1">法会时间</div>
      <div class="introduction1 unfold">
        <!-- <div> 本场法会有以下场次可选：</div> -->
        <span class="push">
          <span class="circle"></span>
          {{meetingInfo?.activityBegin}} 至 {{meetingInfo?.activityEnd}}<br>
        </span>
      </div>
      <div class="introduction2 unfold"></div>
    </div>
    <!-- 法会介绍容器-注意事项 -->
    <div class="introduction-container"
         style="">
      <div class="title">注意事项</div>
      <div class="introduction">
        {{meetingInfo?.attention}}
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="block-72"></div>
    <div class="appointment-enter-container">
      <div class="appointment-enter"
           style=""
           @click="goXinxidengji">法事登记</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "fashidengji",
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      banners: [
        {
          src: require('@/assets/fashidengji.jpg'),
        }
      ],
      currentIndex: 0,
      // 法会信息
      meetingInfo: {}
      // 各个介绍部分信息
    }
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    this.fetchData()
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async fetchData() {
      try {
        const data = await this.$http.get(`/tempt/api/sjte/getRecentActivityDetail?id=${localStorage.getItem("fashidengjiId")}`); // 通过this.$http调用全局挂载的axios实例发送GET请求
        this.meetingInfo = data.result; // 如果请求成功，将返回的数据赋值给data属性用于展示
        this.meetingInfo.price = Number(data.result.price)
        this.$store.commit("updateMeetingInfo", this.meetingInfo);
        localStorage.setItem("meetingInfo", JSON.stringify(this.meetingInfo));
        console.log(this.meetingInfo)
      } catch (error) {
        console.log("error")
      } finally {
        console.log("error2")
      }
    },
    goXinxidengji() {
      this.$router.push("/xinxidengji")
    }
  },

  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.app-content {
}

.banner-container {
  height: 210px;
  position: relative;
}

.van-swipe {
  overflow: hidden;
  position: relative;
  height: 100%;
}

.van-swipe-items-wrap {
  overflow: hidden;
  position: relative;
  height: 100%;
}
.van-swipe-items-wrap > div.is-active {
  display: block;
  -webkit-transform: none;
  transform: none;
}
.van-swipe-items-wrap > div {
  position: absolute;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  width: 100%;
  height: 100%;
  display: none;
}
.van-swipe-item {
  width: 100%;
}
.van-swipe-item img {
  width: 100%;
  height: 100%;
}

.indicator {
  font-family: PingFangSC-Regular;
  position: absolute;
  right: 16px;
  bottom: 24px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  font-size: 10px;
  color: #fff;
  padding: 2px 8px;
}

.communion-title {
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: -16px 12px 16px;
  position: relative;
  z-index: 5;
  width: 94%;
}

.title-text {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 22px;
  color: #000;
  letter-spacing: 0;
  padding: 12px 12px 16px;
}

.communion-title-container {
  display: flex;
  flex-direction: row;
}

.communion-title-container-form {
  margin-bottom: 16px;
  margin-left: 6px;
  margin-top: -3px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  line-height: 20px;
}

.introduction-container {
  margin: 0 16px;
}

.title {
  display: inline-block;
  font-size: 16px;
  color: #000;
  font-family: PingFangSC-Medium;
  font-weight: 500;
}

.introduction {
  white-space: pre-line;
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
}
.introduction1,
.introduction2 {
  width: calc(100vw-32px);
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-family: HelveticaNeue;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 25px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: 0;
}
.push {
  font-size: 14px;
  font-family: HelveticaNeue;
  font-weight: 400;
  color: #000;
  line-height: 20px;
}
.circle {
  width: 4px;
  height: 4px;
  background: #007aaa;
  border-radius: 50%;
  display: inline-block;
  margin: 4px 2px;
}
.block-72 {
  height: 72px;
  width: 100%;
}

.appointment-enter-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 72px;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 93.3%, 0)),
    color-stop(81%, #fff)
  );
  background-image: linear-gradient(180deg, hsla(0, 0%, 93.3%, 0), #fff 81%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.appointment-enter {
  margin: 0 48px;
  font-size: 16px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  color: #fff;
  text-align: center;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  padding: 9px 0;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
}
</style>